import { v4 } from 'uuid';

import { MultiSelectOption } from 'src/legacy/components/Select/types';

import type { CustomFieldSelectCopy } from './CustomFieldSelectPopover';

/** The select picker's copy, shared by the CRM table and the record. */
export const SELECT_PICKER_COPY: CustomFieldSelectCopy = {
  chooseOne: 'Choose one',
  addOption: 'Add option',
  newOptionPlaceholder: 'New option name',
  searchPlaceholder: 'Search options',
  noOptions: 'No options yet.',
  noMatches: 'No matching options.',
  rename: 'Rename',
  remove: 'Remove',
  cancel: 'Cancel',
  clear: 'Clear',
  save: 'Save',
  nameRequired: 'Give the option a name.',
  nameTaken: 'This option already exists.',
};

/** A new option for a select field, added at the end of its list. */
export const createSelectOption = (
  label: string,
  order: number,
): MultiSelectOption => ({
  id: `option-${v4()}`,
  label: label.trim(),
  color: 'none',
  order,
});

export const renameSelectOption = (
  options: MultiSelectOption[],
  optionId: string,
  label: string,
) =>
  options.map((option) =>
    option.id === optionId ? { ...option, label } : option,
  );

export const removeSelectOption = (
  options: MultiSelectOption[],
  optionId: string,
) => options.filter(({ id }) => id !== optionId);
